import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import userStore from "../../../zustand/userStore";
import {
  assignUser,
  clearAssignUser,
  fetchTeachers,
  UnAssignTeachers,
} from "./redux/teacherSlice";
import { updateTeacherUser } from "../../../pages/user/redux/userThunk";

const AllUsers = () => {
  const dispatch = useDispatch();
  const { teacherData, allUsers, loading } = useSelector(
    (state) => state.teachers
  );
  const userData = userStore((state) => state.user);

  const [formData, setFormData] = useState({
    username: "",
    selectedUserId: "",
  });

  useEffect(() => {
    dispatch(UnAssignTeachers());
  }, [dispatch]);

  useEffect(() => {
    if (teacherData) {
      setFormData((prev) => ({
        ...prev,
        username: teacherData.name || "",
      }));
    }
  }, [teacherData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.selectedUserId) {
      alert("Please select a user to assign.");
      return;
    }
    const body = {
      user_id: formData.selectedUserId,
      teacher_id: teacherData.teacher_id,
    };
    console.log("Assigning User to Teacher:", body);
    try {
      await dispatch(updateTeacherUser(body)).unwrap();
      dispatch(fetchTeachers());
      dispatch(clearAssignUser());
    } catch (error) {
      console.error("User assignment failed:", error);
    }
  };

  return (
    <div style={{ padding: "0px", marginTop: "10px" }}>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "16px", rowGap: "12px" }}>
          {/* Teacher (readonly) */}
          <div>
            <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>Teacher</label>
            <input
              type="text"
              name="username"
              className="form-control"
              style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
              value={formData.username}
              readOnly
              disabled
            />
          </div>

          {/* Registered Users Dropdown */}
          <div>
            <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>Registered Users</label>
            <select
              className="form-select"
              style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
              value={formData.selectedUserId}
              onChange={(e) =>
                setFormData({ ...formData, selectedUserId: e.target.value })
              }
              required
            >
              <option value="">Select a user</option>
              {loading ? (
                <option disabled>Loading users...</option>
              ) : Array.isArray(allUsers) && allUsers.length > 0 ? (
                allUsers.map((user) => (
                  <option key={user.user_id} value={user.user_id}>
                    {user.username} ({user.email})
                  </option>
                ))
              ) : (
                <option disabled>No users found</option>
              )}
            </select>
          </div>
        </div>

        {/* Submit Button */}
        <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary" style={{ padding: "6px 24px", fontSize: "13px", borderRadius: "5px" }}>
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default AllUsers;
